import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleMap from '../booking/components/SimpleMap';
import AddressComponent from 'components/components/booking/Map/components/AddressComponent';
import axios from 'components/AppRequest';
import merge from 'lodash/merge';
import CommunicateBox from 'components/components/common/CommunicateBox';
import classNames from 'classnames';
import {
  HOME_TYPE,
  WORK_TYPE,
  OTHER_TYPE
} from 'components/common/constants/addressTypesConstants';
import CustomerAddressValidation from 'components/utils/CustomerAddressValidation';
import { addressDataHelper } from 'components/common/helpers/addressDataHelper';
import resizer from 'components/common/Resizer';
import withRouter from 'components/components/common/withRouter';
import { jumpingMarkerData } from 'components/common/helpers/jumpingMarkerDataHelper';
import {
  createWarningNotification,
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import { connect } from 'react-redux';
import TransHelper from 'components/common/translations/TransHelper';

class MapPlaces extends Component {

  constructor(props, context) {
    super(props, context);
    this.addressFields = {
      phrase: '',
      selectedObject: null,
      error: null,
      postcode: null,
      street: null,
      lat: null,
      lng: null,
    };

    this.state = {
      isLoading: false,
      showButtons: false,
      addressData: this.addressFields,
      addressMarker: null,
      showFavouriteList: false
    };
  }

  trans = (key,prefix = "content.bookingStep3") => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  transNotify = (key) => {
    return this.trans(key,'content.notifications.mapPlaces');
  }

  showFavoriteButtons = () => {
    //when is selected address and there is no error
    if (this.state.addressData.error === null) {
      if (this.state.addressData.selectedObject) {
        var value = true;
        if (this.state.showButtons) {
          value = false;
        }
        this.setState({ showButtons: value });
      } else {
        var state = merge({}, this.state);
        state.addressData.error = this.trans('errors.selectAddress');
        state.showButtons = false;
        this.setState(state);
      }
    } else {
      this.setState({ showButtons: false });
    }
  }

  savePlace = (event, type) => {
    var params = merge({}, this.state.addressData);
    params.type = type;
    var addressHelper = new CustomerAddressValidation(params, this.props.busStops,this.props.locale);
    const isMobile = this.props.windowWidth <= 639;
    if (addressHelper.isValidForm()) {
      var isDuplicated = addressHelper.isDuplicated(this.props.customerAddresses);
      if (isDuplicated) {
        this.props.createWarningNotification({
          title: this.transNotify('warning.title'),
          message: this.transNotify('warning.addressSaved')
        });
        return;
      }
      this.setState({ isLoading: true }, () => {
        axios.post('/pwa/customer/create-address', addressHelper.getRequestParams())
          .then(response => {
            this.resetFields();
            this.props.createSuccessNotification({
              message: this.transNotify('success.addressInDatabase')
            })
            if (isMobile) {
              TransHelper.redirect(this.props, 'routes.url.accountPlaces')
            } else {
              this.props.refreshCustomerAddressesList();
            }
          })
          .catch(err => {
            console.log('err', err)
            this.props.createErrorNotification({
              title: this.transNotify('error'),
              message: this.transNotify('errorMessage')
            })
            this.setState({ isLoading: false });
          });
      })
    } else {
      var newState = merge({}, this.state);
      newState.addressData.error = addressHelper.getError();
      this.setState(newState);
    }
  }

  setDepartureAddressPostcodeErrorLatLng = (error, postcode, street, coordsObj) => {
    var newAddressState = merge(
      {},
      this.state.addressData,
      {
        error,
        postcode,
        street,
        lat: coordsObj ? coordsObj["lat"] : null,
        lng: coordsObj ? coordsObj["lng"] : null,
      }
    );
    var newAddressMarker = merge({}, this.state.addressMarker);
    newAddressMarker.lat = coordsObj['lat'];
    newAddressMarker.lng = coordsObj['lng'];
    if (this.props.editReservationMode) {
      this.props.setChosenAddress(newAddressState);
    }

    this.setState(
      {
        addressMarker: newAddressMarker,
        addressData: newAddressState,
        showButtons: error === null
      }
    );
  }

  resetFields = () => {
    this.setState(
      {
        addressData: this.addressFields,
        isLoading: false,
        showButtons: false,
        addressMarker: null
      }
    )
  }

  onPhraseChange = (event) => {
    var state = merge({}, this.state);
    state.addressData.phrase = event.target.value;
    this.setState(state);
  }

  onItemChoose = (item) => {
    var newState = merge({}, this.state);
    newState.addressData = {
      error: null,
      postcode: null,
      street: null,
      lat: null,
      lng: null,
    };
    newState.addressData.selectedObject = item;
    newState.addressData.phrase = item.label;
    newState.addressMarker = item;
    if (this.props.editReservationMode) {
      this.props.setChosenAddress(newState.addressData);
    }
    this.setState(newState);
  }

  getMarkersData = () => {
    const { customerAddresses: addresses } = this.props;
    var results = [];
    for (var i = 0; i < addresses.length; i++) {
      var address = addresses[i];
      const { icon, label } = addressDataHelper(address.type);
      results.push({
        lat: address.lat,
        lng: address.lng,
        icon: icon,
        label: label
      })
    }
    return results;
  }

  jumpingMarkerData = () => {
    const { addressMarker } = this.state;
    return [jumpingMarkerData(addressMarker, this.props.busStops)];
  }

  handleShowFavouriteList = (value) => {
    if (value === true || value === false) {
      this.setState({ showFavouriteList: value });
    } else {
      this.setState({
        showFavouriteList: !this.state.showFavouriteList,
      });
    }
  }

  render() {
    const { addressData, showButtons, isLoading } = this.state;
    const { editReservationMode } = this.props;
    if (!editReservationMode) {
      var buttonElement = (
        <button
          className="button button--add-fovorite"
          onClick={this.showFavoriteButtons}
          disabled={this.isLoading}
        >
          {
            isLoading
              ?
              (<i className="loader" />)
              :
              this.trans('map.addToFav')
          }
        </button>
      );
    } else {
      var buttonElement = null;
    }

    var favoriteListClass = classNames(
      'map-favorite',
      { 'map-favorite--active': showButtons && !editReservationMode }
    );

    return (
      <Fragment>
        <CommunicateBox message={addressData.error} />
        <div className="map-select-container">
          <div id="sectionMap" className="map-select__wrap">
            <AddressComponent
              addressData={addressData}
              busStops={this.props.busStops}
              customerAddresses={this.props.customerAddresses}
              disableCustomerAddresses={this.props.disableCustomerAddresses}
              handleShowFavouriteList={this.handleShowFavouriteList}
              isValid={addressData.error === null}
              onItemChoose={this.onItemChoose}
              onPhraseChange={this.onPhraseChange}
              setAddressPostcodeErrorLatLng={this.setDepartureAddressPostcodeErrorLatLng}
              showFavouriteList={this.state.showFavouriteList}
            />
          </div>
          {buttonElement}
        </div>
        {buttonElement}

        {!editReservationMode && (
          <ul className={favoriteListClass}>
            <li className="map-favorite__item">
              <button
                title={this.trans('spots.home')}
                onClick={(e) => this.savePlace(e, HOME_TYPE)}
              >
                <FontAwesomeIcon
                  icon={['fas', 'hotel']}
                  size="lg"
                />
                <span>{this.trans('spots.home')}</span>
              </button>
            </li>

            <li className="map-favorite__item">
              <button
                title={this.trans('spots.work')}
                onClick={(e) => this.savePlace(e, WORK_TYPE)}
              >
                <FontAwesomeIcon
                  icon={['fas', 'briefcase']}
                  size="lg"
                />
                <span>{this.trans('spots.work')}</span>
              </button>
            </li>

            <li className="map-favorite__item">
              <button
                title={this.trans('spots.other')}
                onClick={(e) => this.savePlace(e, OTHER_TYPE)}
              >
                <FontAwesomeIcon
                  icon={['fas', 'star']}
                  size="lg"
                />
                <span>{this.trans('spots.other')}</span>
              </button>
            </li>
          </ul>
        )}

        <SimpleMap
          jumpingMarkers={this.jumpingMarkerData()}
          markers={this.getMarkersData()}
        />

      </Fragment>
    );
  }
}

export default withRouter(
  resizer(
    connect(null,
      { createWarningNotification, createSuccessNotification, createErrorNotification }
    )(MapPlaces)
  )
);
